export default {
    zh: {
        title: '申请注销账号',
        subtitle: '请在操作前仔细阅读以下说明',
        noticePre: '您正在申请注销账号。为了保障您的权益，我们将在',
        noticeDays: '7天',
        noticePost: '后正式处理您的注销请求。在此期间，您可以随时撤销申请。',
        consequenceTitle: '注销后果告知',
        historyTitle: '历史记录清空',
        historyDesc: '您的所有历史订单、订阅记录将被永久删除且无法恢复。',
        assetTitle: '资产清零',
        assetDesc: '账号内剩余的积分、余额、会员时长将全部清零，无法退还。',
        identityTitle: '身份注销',
        identityDesc: '注销完成后，您将无法再使用此账号登录或找回数据。',
        confirmBtn: '确认申请注销',
        thinkAgainBtn: '我再想想',
        submittedTitle: '注销申请已提交',
        submittedDescPre: '您的账号将于 ',
        submittedDescPost: ' 正式完成注销',
        submittedDescHint: '在此期间，您可以随时撤销申请。',
        countdownDay: 'Day',
        countdownHours: 'Hours',
        countdownMinutes: 'Minutes',
        cancelBtn: '取消注销',
        cancelHint: '取消注销后，您的账号将立即恢复正常使用。',
        cancelSuccess: '注销申请已撤销，账号已恢复正常',
        back: '返回',
        deleteAccount: '注销账号',
    },
    en: {
        title: 'Request Account Deletion',
        subtitle: 'Please read the following carefully before proceeding',
        noticePre: 'You are requesting account deletion. To protect your rights, we will process your deletion request after ',
        noticeDays: '7 days',
        noticePost: '. During this period, you can withdraw your request at any time.',
        consequenceTitle: 'Consequences of Deletion',
        historyTitle: 'History Cleared',
        historyDesc: 'All your order and subscription history will be permanently deleted and cannot be recovered.',
        assetTitle: 'Assets Cleared',
        assetDesc: 'All remaining credits, balance, and membership duration will be cleared and cannot be refunded.',
        identityTitle: 'Identity Deleted',
        identityDesc: 'After deletion, you will no longer be able to log in or recover data with this account.',
        confirmBtn: 'Confirm Deletion Request',
        thinkAgainBtn: 'Let Me Think Again',
        submittedTitle: 'Deletion Request Submitted',
        submittedDescPre: 'Your account will be permanently deleted on ',
        submittedDescPost: '',
        submittedDescHint: 'During this period, you can withdraw your request at any time.',
        countdownDay: 'Day',
        countdownHours: 'Hours',
        countdownMinutes: 'Minutes',
        cancelBtn: 'Cancel Deletion',
        cancelHint: 'After cancellation, your account will be restored to normal immediately.',
        cancelSuccess: 'Deletion request has been withdrawn, your account is restored',
        back: 'Back',
        deleteAccount: 'Delete Account',
    },
    ja: {
        title: 'アカウント削除申請',
        subtitle: '操作前に以下の説明をよくお読みください',
        noticePre: 'アカウント削除を申請中です。お客様の権益を保護するため、',
        noticeDays: '7日',
        noticePost: '後に正式に削除処理を行います。この期間中、いつでも申請を取り消すことができます。',
        consequenceTitle: '削除の結果について',
        historyTitle: '履歴の消去',
        historyDesc: 'すべての注文履歴、サブスクリプション記録が永久に削除され、復元できません。',
        assetTitle: '資産のクリア',
        assetDesc: 'アカウント内の残りのポイント、残高、会員期間はすべてクリアされ、返金できません。',
        identityTitle: 'アカウント削除',
        identityDesc: '削除完了後、このアカウントでのログインやデータの復元はできなくなります。',
        confirmBtn: '削除申請を確認',
        thinkAgainBtn: 'もう一度考える',
        submittedTitle: '削除申請が送信されました',
        submittedDescPre: 'お客様のアカウントは ',
        submittedDescPost: ' に正式に削除されます',
        submittedDescHint: 'この期間中、いつでも申請を取り消すことができます。',
        countdownDay: 'Day',
        countdownHours: 'Hours',
        countdownMinutes: 'Minutes',
        cancelBtn: '削除をキャンセル',
        cancelHint: 'キャンセル後、アカウントは直ちに通常通り使用できるようになります。',
        cancelSuccess: '削除申請が取り消されました。アカウントは正常に復元されました',
        back: '戻る',
        deleteAccount: 'アカウント削除',
    },
    ko: {
        title: '계정 삭제 신청',
        subtitle: '진행하기 전에 다음 내용을 주의 깊게 읽어주세요',
        noticePre: '계정 삭제를 신청 중입니다. 귀하의 권익을 보호하기 위해 ',
        noticeDays: '7일',
        noticePost: ' 후에 정식으로 삭제 처리됩니다. 이 기간 동안 언제든지 신청을 철회할 수 있습니다.',
        consequenceTitle: '삭제 결과 안내',
        historyTitle: '기록 삭제',
        historyDesc: '모든 주문 및 구독 기록이 영구적으로 삭제되며 복구할 수 없습니다.',
        assetTitle: '자산 초기화',
        assetDesc: '계정의 남은 포인트, 잔액, 멤버십 기간이 모두 초기화되며 환불이 불가합니다.',
        identityTitle: '계정 삭제',
        identityDesc: '삭제 완료 후 이 계정으로 로그인하거나 데이터를 복구할 수 없습니다.',
        confirmBtn: '삭제 신청 확인',
        thinkAgainBtn: '다시 생각해볼게요',
        submittedTitle: '삭제 신청이 제출되었습니다',
        submittedDescPre: '귀하의 계정은 ',
        submittedDescPost: ' 에 정식으로 삭제됩니다',
        submittedDescHint: '이 기간 동안 언제든지 신청을 철회할 수 있습니다.',
        countdownDay: 'Day',
        countdownHours: 'Hours',
        countdownMinutes: 'Minutes',
        cancelBtn: '삭제 취소',
        cancelHint: '취소 후 계정이 즉시 정상으로 복원됩니다.',
        cancelSuccess: '삭제 신청이 철회되었습니다. 계정이 정상으로 복원되었습니다',
        back: '돌아가기',
        deleteAccount: '계정 삭제',
    },
    tw: {
        title: '申請註銷帳號',
        subtitle: '請在操作前仔細閱讀以下說明',
        noticePre: '您正在申請註銷帳號。為了保障您的權益，我們將在',
        noticeDays: '7天',
        noticePost: '後正式處理您的註銷請求。在此期間，您可以隨時撤銷申請。',
        consequenceTitle: '註銷後果告知',
        historyTitle: '歷史記錄清空',
        historyDesc: '您的所有歷史訂單、訂閱記錄將被永久刪除且無法恢復。',
        assetTitle: '資產清零',
        assetDesc: '帳號內剩餘的積分、餘額、會員時長將全部清零，無法退還。',
        identityTitle: '身份註銷',
        identityDesc: '註銷完成後，您將無法再使用此帳號登入或找回數據。',
        confirmBtn: '確認申請註銷',
        thinkAgainBtn: '我再想想',
        submittedTitle: '註銷申請已提交',
        submittedDescPre: '您的帳號將於 ',
        submittedDescPost: ' 正式完成註銷',
        submittedDescHint: '在此期間，您可以隨時撤銷申請。',
        countdownDay: 'Day',
        countdownHours: 'Hours',
        countdownMinutes: 'Minutes',
        cancelBtn: '取消註銷',
        cancelHint: '取消註銷後，您的帳號將立即恢復正常使用。',
        cancelSuccess: '註銷申請已撤銷，帳號已恢復正常',
        back: '返回',
        deleteAccount: '註銷帳號',
    },
    es: {
        title: 'Solicitar eliminación de cuenta',
        subtitle: 'Por favor lea lo siguiente antes de continuar',
        noticePre: 'Está solicitando la eliminación de su cuenta. Para proteger sus derechos, procesaremos su solicitud después de ',
        noticeDays: '7 días',
        noticePost: '. Durante este período, puede retirar su solicitud en cualquier momento.',
        consequenceTitle: 'Consecuencias de la eliminación',
        historyTitle: 'Historial eliminado',
        historyDesc: 'Todo su historial de pedidos y suscripciones será eliminado permanentemente y no podrá recuperarse.',
        assetTitle: 'Activos eliminados',
        assetDesc: 'Todos los créditos, saldo y duración de membresía restantes serán eliminados y no podrán reembolsarse.',
        identityTitle: 'Identidad eliminada',
        identityDesc: 'Después de la eliminación, no podrá iniciar sesión ni recuperar datos con esta cuenta.',
        confirmBtn: 'Confirmar solicitud',
        thinkAgainBtn: 'Déjame pensarlo',
        submittedTitle: 'Solicitud enviada',
        submittedDescPre: 'Su cuenta será eliminada permanentemente el ',
        submittedDescPost: '',
        submittedDescHint: 'Durante este período, puede retirar su solicitud en cualquier momento.',
        countdownDay: 'Day',
        countdownHours: 'Hours',
        countdownMinutes: 'Minutes',
        cancelBtn: 'Cancelar eliminación',
        cancelHint: 'Después de cancelar, su cuenta se restaurará de inmediato.',
        cancelSuccess: 'La solicitud ha sido retirada, su cuenta ha sido restaurada',
        back: 'Volver',
        deleteAccount: 'Eliminar cuenta',
    },
    fr: {
        title: 'Demande de suppression de compte',
        subtitle: 'Veuillez lire attentivement ce qui suit avant de continuer',
        noticePre: 'Vous demandez la suppression de votre compte. Pour protéger vos droits, nous traiterons votre demande après ',
        noticeDays: '7 jours',
        noticePost: '. Pendant cette période, vous pouvez retirer votre demande à tout moment.',
        consequenceTitle: 'Conséquences de la suppression',
        historyTitle: 'Historique effacé',
        historyDesc: 'Tout votre historique de commandes et d\'abonnements sera définitivement supprimé et ne pourra pas être récupéré.',
        assetTitle: 'Actifs effacés',
        assetDesc: 'Tous les crédits, solde et durée d\'adhésion restants seront effacés et ne pourront pas être remboursés.',
        identityTitle: 'Identité supprimée',
        identityDesc: 'Après la suppression, vous ne pourrez plus vous connecter ni récupérer les données avec ce compte.',
        confirmBtn: 'Confirmer la demande',
        thinkAgainBtn: 'Laissez-moi réfléchir',
        submittedTitle: 'Demande soumise',
        submittedDescPre: 'Votre compte sera définitivement supprimé le ',
        submittedDescPost: '',
        submittedDescHint: 'Pendant cette période, vous pouvez retirer votre demande à tout moment.',
        countdownDay: 'Day',
        countdownHours: 'Hours',
        countdownMinutes: 'Minutes',
        cancelBtn: 'Annuler la suppression',
        cancelHint: 'Après annulation, votre compte sera immédiatement restauré.',
        cancelSuccess: 'La demande a été retirée, votre compte est restauré',
        back: 'Retour',
        deleteAccount: 'Supprimer le compte',
    },
    de: {
        title: 'Kontolöschung beantragen',
        subtitle: 'Bitte lesen Sie die folgenden Hinweise sorgfältig durch',
        noticePre: 'Sie beantragen die Löschung Ihres Kontos. Zum Schutz Ihrer Rechte werden wir Ihren Antrag nach ',
        noticeDays: '7 Tagen',
        noticePost: ' bearbeiten. In dieser Zeit können Sie Ihren Antrag jederzeit zurückziehen.',
        consequenceTitle: 'Folgen der Löschung',
        historyTitle: 'Verlauf gelöscht',
        historyDesc: 'Ihr gesamter Bestell- und Abonnementverlauf wird dauerhaft gelöscht und kann nicht wiederhergestellt werden.',
        assetTitle: 'Guthaben gelöscht',
        assetDesc: 'Alle verbleibenden Credits, Guthaben und Mitgliedschaftsdauer werden gelöscht und können nicht erstattet werden.',
        identityTitle: 'Identität gelöscht',
        identityDesc: 'Nach der Löschung können Sie sich nicht mehr anmelden oder Daten mit diesem Konto wiederherstellen.',
        confirmBtn: 'Löschung bestätigen',
        thinkAgainBtn: 'Nochmal überlegen',
        submittedTitle: 'Antrag eingereicht',
        submittedDescPre: 'Ihr Konto wird am ',
        submittedDescPost: ' endgültig gelöscht',
        submittedDescHint: 'In dieser Zeit können Sie Ihren Antrag jederzeit zurückziehen.',
        countdownDay: 'Day',
        countdownHours: 'Hours',
        countdownMinutes: 'Minutes',
        cancelBtn: 'Löschung abbrechen',
        cancelHint: 'Nach der Stornierung wird Ihr Konto sofort wiederhergestellt.',
        cancelSuccess: 'Der Antrag wurde zurückgezogen, Ihr Konto wurde wiederhergestellt',
        back: 'Zurück',
        deleteAccount: 'Konto löschen',
    },
    ru: {
        title: 'Запрос на удаление аккаунта',
        subtitle: 'Пожалуйста, внимательно прочитайте следующее',
        noticePre: 'Вы запрашиваете удаление аккаунта. Для защиты ваших прав мы обработаем ваш запрос через ',
        noticeDays: '7 дней',
        noticePost: '. В течение этого периода вы можете отозвать свой запрос в любое время.',
        consequenceTitle: 'Последствия удаления',
        historyTitle: 'История очищена',
        historyDesc: 'Вся история заказов и подписок будет безвозвратно удалена.',
        assetTitle: 'Активы обнулены',
        assetDesc: 'Все оставшиеся кредиты, баланс и срок подписки будут обнулены без возврата.',
        identityTitle: 'Аккаунт удалён',
        identityDesc: 'После удаления вы не сможете войти или восстановить данные этого аккаунта.',
        confirmBtn: 'Подтвердить запрос',
        thinkAgainBtn: 'Подумаю ещё',
        submittedTitle: 'Запрос отправлен',
        submittedDescPre: 'Ваш аккаунт будет удалён ',
        submittedDescPost: '',
        submittedDescHint: 'В течение этого периода вы можете отозвать свой запрос.',
        countdownDay: 'Day',
        countdownHours: 'Hours',
        countdownMinutes: 'Minutes',
        cancelBtn: 'Отменить удаление',
        cancelHint: 'После отмены ваш аккаунт будет немедленно восстановлен.',
        cancelSuccess: 'Запрос отозван, ваш аккаунт восстановлен',
        back: 'Назад',
        deleteAccount: 'Удалить аккаунт',
    },
    pt: {
        title: 'Solicitar exclusão de conta',
        subtitle: 'Por favor, leia o seguinte antes de prosseguir',
        noticePre: 'Você está solicitando a exclusão da conta. Para proteger seus direitos, processaremos sua solicitação após ',
        noticeDays: '7 dias',
        noticePost: '. Durante este período, você pode retirar sua solicitação a qualquer momento.',
        consequenceTitle: 'Consequências da exclusão',
        historyTitle: 'Histórico apagado',
        historyDesc: 'Todo o histórico de pedidos e assinaturas será permanentemente excluído e não poderá ser recuperado.',
        assetTitle: 'Ativos zerados',
        assetDesc: 'Todos os créditos, saldo e duração de assinatura restantes serão zerados e não poderão ser reembolsados.',
        identityTitle: 'Identidade excluída',
        identityDesc: 'Após a exclusão, você não poderá mais fazer login ou recuperar dados com esta conta.',
        confirmBtn: 'Confirmar solicitação',
        thinkAgainBtn: 'Deixe-me pensar',
        submittedTitle: 'Solicitação enviada',
        submittedDescPre: 'Sua conta será permanentemente excluída em ',
        submittedDescPost: '',
        submittedDescHint: 'Durante este período, você pode retirar sua solicitação a qualquer momento.',
        countdownDay: 'Day',
        countdownHours: 'Hours',
        countdownMinutes: 'Minutes',
        cancelBtn: 'Cancelar exclusão',
        cancelHint: 'Após o cancelamento, sua conta será restaurada imediatamente.',
        cancelSuccess: 'Solicitação retirada, sua conta foi restaurada',
        back: 'Voltar',
        deleteAccount: 'Excluir conta',
    },
    it: {
        title: 'Richiedi eliminazione account',
        subtitle: 'Si prega di leggere attentamente quanto segue',
        noticePre: 'Stai richiedendo l\'eliminazione del tuo account. Per proteggere i tuoi diritti, elaboreremo la tua richiesta dopo ',
        noticeDays: '7 giorni',
        noticePost: '. Durante questo periodo, puoi ritirare la tua richiesta in qualsiasi momento.',
        consequenceTitle: 'Conseguenze dell\'eliminazione',
        historyTitle: 'Cronologia cancellata',
        historyDesc: 'Tutta la cronologia degli ordini e degli abbonamenti verrà eliminata permanentemente e non potrà essere recuperata.',
        assetTitle: 'Risorse azzerate',
        assetDesc: 'Tutti i crediti, il saldo e la durata dell\'abbonamento rimanenti verranno azzerati e non potranno essere rimborsati.',
        identityTitle: 'Identità eliminata',
        identityDesc: 'Dopo l\'eliminazione, non potrai più accedere o recuperare i dati con questo account.',
        confirmBtn: 'Conferma richiesta',
        thinkAgainBtn: 'Ci penso',
        submittedTitle: 'Richiesta inviata',
        submittedDescPre: 'Il tuo account verrà eliminato definitivamente il ',
        submittedDescPost: '',
        submittedDescHint: 'Durante questo periodo, puoi ritirare la tua richiesta in qualsiasi momento.',
        countdownDay: 'Day',
        countdownHours: 'Hours',
        countdownMinutes: 'Minutes',
        cancelBtn: 'Annulla eliminazione',
        cancelHint: 'Dopo l\'annullamento, il tuo account verrà ripristinato immediatamente.',
        cancelSuccess: 'La richiesta è stata ritirata, il tuo account è stato ripristinato',
        back: 'Indietro',
        deleteAccount: 'Elimina account',
    },
    ar: {
        title: 'طلب حذف الحساب',
        subtitle: 'يرجى قراءة ما يلي بعناية قبل المتابعة',
        noticePre: 'أنت تطلب حذف حسابك. لحماية حقوقك، سنعالج طلبك بعد ',
        noticeDays: '7 أيام',
        noticePost: '. خلال هذه الفترة، يمكنك سحب طلبك في أي وقت.',
        consequenceTitle: 'عواقب الحذف',
        historyTitle: 'مسح السجل',
        historyDesc: 'سيتم حذف جميع سجلات الطلبات والاشتراكات بشكل دائم ولا يمكن استعادتها.',
        assetTitle: 'تصفير الأصول',
        assetDesc: 'سيتم تصفير جميع الرصيد والنقاط ومدة العضوية المتبقية ولا يمكن استردادها.',
        identityTitle: 'حذف الهوية',
        identityDesc: 'بعد الحذف، لن تتمكن من تسجيل الدخول أو استعادة البيانات بهذا الحساب.',
        confirmBtn: 'تأكيد الطلب',
        thinkAgainBtn: 'دعني أفكر',
        submittedTitle: 'تم تقديم الطلب',
        submittedDescPre: 'سيتم حذف حسابك نهائياً في ',
        submittedDescPost: '',
        submittedDescHint: 'خلال هذه الفترة، يمكنك سحب طلبك في أي وقت.',
        countdownDay: 'Day',
        countdownHours: 'Hours',
        countdownMinutes: 'Minutes',
        cancelBtn: 'إلغاء الحذف',
        cancelHint: 'بعد الإلغاء، سيتم استعادة حسابك فوراً.',
        cancelSuccess: 'تم سحب الطلب، تمت استعادة حسابك',
        back: 'رجوع',
        deleteAccount: 'حذف الحساب',
    },
    th: {
        title: 'ขอลบบัญชี',
        subtitle: 'กรุณาอ่านข้อมูลต่อไปนี้อย่างละเอียดก่อนดำเนินการ',
        noticePre: 'คุณกำลังขอลบบัญชี เพื่อปกป้องสิทธิ์ของคุณ เราจะดำเนินการหลังจาก ',
        noticeDays: '7 วัน',
        noticePost: ' ในระหว่างนี้คุณสามารถถอนคำขอได้ตลอดเวลา',
        consequenceTitle: 'ผลที่ตามมาจากการลบ',
        historyTitle: 'ล้างประวัติ',
        historyDesc: 'ประวัติคำสั่งซื้อและการสมัครสมาชิกทั้งหมดจะถูกลบอย่างถาวรและไม่สามารถกู้คืนได้',
        assetTitle: 'ล้างทรัพย์สิน',
        assetDesc: 'เครดิต ยอดคงเหลือ และระยะเวลาสมาชิกที่เหลือทั้งหมดจะถูกล้างและไม่สามารถคืนเงินได้',
        identityTitle: 'ลบตัวตน',
        identityDesc: 'หลังจากลบแล้ว คุณจะไม่สามารถเข้าสู่ระบบหรือกู้คืนข้อมูลด้วยบัญชีนี้ได้อีก',
        confirmBtn: 'ยืนยันคำขอ',
        thinkAgainBtn: 'ขอคิดอีกที',
        submittedTitle: 'ส่งคำขอแล้ว',
        submittedDescPre: 'บัญชีของคุณจะถูกลบอย่างถาวรในวันที่ ',
        submittedDescPost: '',
        submittedDescHint: 'ในระหว่างนี้คุณสามารถถอนคำขอได้ตลอดเวลา',
        countdownDay: 'Day',
        countdownHours: 'Hours',
        countdownMinutes: 'Minutes',
        cancelBtn: 'ยกเลิกการลบ',
        cancelHint: 'หลังจากยกเลิก บัญชีของคุณจะกลับสู่สถานะปกติทันที',
        cancelSuccess: 'คำขอถูกถอน บัญชีของคุณกลับสู่สถานะปกติแล้ว',
        back: 'กลับ',
        deleteAccount: 'ลบบัญชี',
    },
    pl: {
        title: 'Żądanie usunięcia konta',
        subtitle: 'Proszę uważnie przeczytać poniższe informacje',
        noticePre: 'Żądasz usunięcia konta. Aby chronić Twoje prawa, przetworzymy Twoje żądanie po ',
        noticeDays: '7 dniach',
        noticePost: '. W tym czasie możesz wycofać swoje żądanie w dowolnym momencie.',
        consequenceTitle: 'Konsekwencje usunięcia',
        historyTitle: 'Historia wyczyszczona',
        historyDesc: 'Cała historia zamówień i subskrypcji zostanie trwale usunięta i nie będzie mogła zostać odzyskana.',
        assetTitle: 'Zasoby wyzerowane',
        assetDesc: 'Wszystkie pozostałe kredyty, saldo i czas członkostwa zostaną wyzerowane i nie podlegają zwrotowi.',
        identityTitle: 'Tożsamość usunięta',
        identityDesc: 'Po usunięciu nie będziesz mógł się zalogować ani odzyskać danych z tego konta.',
        confirmBtn: 'Potwierdź żądanie',
        thinkAgainBtn: 'Przemyślę to',
        submittedTitle: 'Żądanie wysłane',
        submittedDescPre: 'Twoje konto zostanie trwale usunięte ',
        submittedDescPost: '',
        submittedDescHint: 'W tym czasie możesz wycofać swoje żądanie w dowolnym momencie.',
        countdownDay: 'Day',
        countdownHours: 'Hours',
        countdownMinutes: 'Minutes',
        cancelBtn: 'Anuluj usunięcie',
        cancelHint: 'Po anulowaniu Twoje konto zostanie natychmiast przywrócone.',
        cancelSuccess: 'Żądanie zostało wycofane, Twoje konto zostało przywrócone',
        back: 'Wstecz',
        deleteAccount: 'Usuń konto',
    },
    da: {
        title: 'Anmod om kontosletning',
        subtitle: 'Læs venligst følgende omhyggeligt',
        noticePre: 'Du anmoder om sletning af din konto. For at beskytte dine rettigheder behandler vi din anmodning efter ',
        noticeDays: '7 dage',
        noticePost: '. I denne periode kan du trække din anmodning tilbage.',
        consequenceTitle: 'Konsekvenser af sletning',
        historyTitle: 'Historik slettet',
        historyDesc: 'Al ordre- og abonnementshistorik slettes permanent og kan ikke gendannes.',
        assetTitle: 'Aktiver nulstillet',
        assetDesc: 'Alle resterende credits, saldo og medlemskabsvarighed nulstilles og kan ikke refunderes.',
        identityTitle: 'Identitet slettet',
        identityDesc: 'Efter sletning kan du ikke længere logge ind eller gendanne data.',
        confirmBtn: 'Bekræft anmodning',
        thinkAgainBtn: 'Lad mig tænke',
        submittedTitle: 'Anmodning indsendt',
        submittedDescPre: 'Din konto slettes permanent den ',
        submittedDescPost: '',
        submittedDescHint: 'I denne periode kan du trække din anmodning tilbage.',
        countdownDay: 'Day',
        countdownHours: 'Hours',
        countdownMinutes: 'Minutes',
        cancelBtn: 'Annuller sletning',
        cancelHint: 'Efter annullering gendannes din konto med det samme.',
        cancelSuccess: 'Anmodningen er trukket tilbage, din konto er gendannet',
        back: 'Tilbage',
        deleteAccount: 'Slet konto',
    },
    no: {
        title: 'Be om sletting av konto',
        subtitle: 'Vennligst les følgende nøye',
        noticePre: 'Du ber om sletting av kontoen din. For å beskytte dine rettigheter vil vi behandle forespørselen etter ',
        noticeDays: '7 dager',
        noticePost: '. I denne perioden kan du trekke tilbake forespørselen når som helst.',
        consequenceTitle: 'Konsekvenser av sletting',
        historyTitle: 'Historikk slettet',
        historyDesc: 'All ordre- og abonnementshistorikk slettes permanent og kan ikke gjenopprettes.',
        assetTitle: 'Eiendeler nullstilt',
        assetDesc: 'Alle gjenværende kreditter, saldo og medlemsvarighet nullstilles og kan ikke refunderes.',
        identityTitle: 'Identitet slettet',
        identityDesc: 'Etter sletting kan du ikke lenger logge inn eller gjenopprette data.',
        confirmBtn: 'Bekreft forespørsel',
        thinkAgainBtn: 'La meg tenke',
        submittedTitle: 'Forespørsel sendt',
        submittedDescPre: 'Kontoen din slettes permanent den ',
        submittedDescPost: '',
        submittedDescHint: 'I denne perioden kan du trekke tilbake forespørselen når som helst.',
        countdownDay: 'Day',
        countdownHours: 'Hours',
        countdownMinutes: 'Minutes',
        cancelBtn: 'Avbryt sletting',
        cancelHint: 'Etter avbestilling gjenopprettes kontoen din umiddelbart.',
        cancelSuccess: 'Forespørselen er trukket tilbake, kontoen din er gjenopprettet',
        back: 'Tilbake',
        deleteAccount: 'Slett konto',
    },
    nl: {
        title: 'Account verwijderen aanvragen',
        subtitle: 'Lees het volgende aandachtig door',
        noticePre: 'U vraagt het verwijderen van uw account aan. Om uw rechten te beschermen, verwerken we uw verzoek na ',
        noticeDays: '7 dagen',
        noticePost: '. Gedurende deze periode kunt u uw verzoek op elk moment intrekken.',
        consequenceTitle: 'Gevolgen van verwijdering',
        historyTitle: 'Geschiedenis gewist',
        historyDesc: 'Alle bestel- en abonnementsgeschiedenis wordt permanent verwijderd en kan niet worden hersteld.',
        assetTitle: 'Tegoeden gewist',
        assetDesc: 'Alle resterende credits, saldo en lidmaatschapsduur worden gewist en kunnen niet worden terugbetaald.',
        identityTitle: 'Identiteit verwijderd',
        identityDesc: 'Na verwijdering kunt u niet meer inloggen of gegevens herstellen.',
        confirmBtn: 'Verzoek bevestigen',
        thinkAgainBtn: 'Laat me nadenken',
        submittedTitle: 'Verzoek ingediend',
        submittedDescPre: 'Uw account wordt permanent verwijderd op ',
        submittedDescPost: '',
        submittedDescHint: 'Gedurende deze periode kunt u uw verzoek op elk moment intrekken.',
        countdownDay: 'Day',
        countdownHours: 'Hours',
        countdownMinutes: 'Minutes',
        cancelBtn: 'Verwijdering annuleren',
        cancelHint: 'Na annulering wordt uw account onmiddellijk hersteld.',
        cancelSuccess: 'Het verzoek is ingetrokken, uw account is hersteld',
        back: 'Terug',
        deleteAccount: 'Account verwijderen',
    },
    id: {
        title: 'Ajukan penghapusan akun',
        subtitle: 'Silakan baca informasi berikut dengan seksama',
        noticePre: 'Anda mengajukan penghapusan akun. Untuk melindungi hak Anda, kami akan memproses permintaan Anda setelah ',
        noticeDays: '7 hari',
        noticePost: '. Selama periode ini, Anda dapat menarik permintaan kapan saja.',
        consequenceTitle: 'Konsekuensi penghapusan',
        historyTitle: 'Riwayat dihapus',
        historyDesc: 'Semua riwayat pesanan dan langganan akan dihapus secara permanen dan tidak dapat dipulihkan.',
        assetTitle: 'Aset dinolkan',
        assetDesc: 'Semua kredit, saldo, dan durasi keanggotaan yang tersisa akan dinolkan dan tidak dapat dikembalikan.',
        identityTitle: 'Identitas dihapus',
        identityDesc: 'Setelah penghapusan, Anda tidak dapat lagi masuk atau memulihkan data dengan akun ini.',
        confirmBtn: 'Konfirmasi permintaan',
        thinkAgainBtn: 'Biar saya pikir lagi',
        submittedTitle: 'Permintaan terkirim',
        submittedDescPre: 'Akun Anda akan dihapus secara permanen pada ',
        submittedDescPost: '',
        submittedDescHint: 'Selama periode ini, Anda dapat menarik permintaan kapan saja.',
        countdownDay: 'Day',
        countdownHours: 'Hours',
        countdownMinutes: 'Minutes',
        cancelBtn: 'Batalkan penghapusan',
        cancelHint: 'Setelah pembatalan, akun Anda akan segera dipulihkan.',
        cancelSuccess: 'Permintaan ditarik, akun Anda telah dipulihkan',
        back: 'Kembali',
        deleteAccount: 'Hapus akun',
    },
    tr: {
        title: 'Hesap silme talebi',
        subtitle: 'Devam etmeden önce lütfen aşağıdakileri dikkatlice okuyun',
        noticePre: 'Hesabınızın silinmesini talep ediyorsunuz. Haklarınızı korumak için talebinizi ',
        noticeDays: '7 gün',
        noticePost: ' sonra işleme alacağız. Bu süre zarfında talebinizi istediğiniz zaman geri çekebilirsiniz.',
        consequenceTitle: 'Silme sonuçları',
        historyTitle: 'Geçmiş temizlendi',
        historyDesc: 'Tüm sipariş ve abonelik geçmişiniz kalıcı olarak silinecek ve kurtarılamayacaktır.',
        assetTitle: 'Varlıklar sıfırlandı',
        assetDesc: 'Kalan tüm krediler, bakiye ve üyelik süresi sıfırlanacak ve iade edilemeyecektir.',
        identityTitle: 'Kimlik silindi',
        identityDesc: 'Silme işleminden sonra bu hesapla giriş yapamaz veya verileri kurtaramazsınız.',
        confirmBtn: 'Talebi onayla',
        thinkAgainBtn: 'Düşüneyim',
        submittedTitle: 'Talep gönderildi',
        submittedDescPre: 'Hesabınız ',
        submittedDescPost: ' tarihinde kalıcı olarak silinecektir',
        submittedDescHint: 'Bu süre zarfında talebinizi istediğiniz zaman geri çekebilirsiniz.',
        countdownDay: 'Day',
        countdownHours: 'Hours',
        countdownMinutes: 'Minutes',
        cancelBtn: 'Silmeyi iptal et',
        cancelHint: 'İptalden sonra hesabınız hemen geri yüklenecektir.',
        cancelSuccess: 'Talep geri çekildi, hesabınız geri yüklendi',
        back: 'Geri',
        deleteAccount: 'Hesabı sil',
    },
}
